import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { AuthService } from "../services/auth.service";
import { SnackService } from "../../../shared/services/snack-service.service";
import { JustupOffre } from "../../activity_infos/justup-offre.enum";

@Injectable({
  providedIn: "root",
})
export class OffreGuard implements CanActivate {
  constructor(
    public authService: AuthService,
    private snackService: SnackService,
    private router: Router,
  ) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Promise<boolean> {
    let plan = route.data?.plan as JustupOffre[];
    let currentOffre = this.authService.offreSignal();

    if (!plan || !plan.length) {
      return true;
    }

    const canActivate = plan.includes(currentOffre);

    if (!canActivate) {
      this.snackService.info(
        "Vous n'avez pas accès à cette fonctionnalité, veuillez contacter le service commercial de JustUp",
      );
      this.router.navigate(["/auth/login"]);
    }

    return canActivate;
  }
}
